module.exports = __webpack_public_path__ + "static/media/huoshishan_package.77fd5a89.webp";